import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom';
import { Element } from 'react-scroll'

function Feature() {
    const data = [
        {
        image:"https://img.icons8.com/pastel-glyph/50/12B886/handshake--v2.png",
        title:"Job Oriented Session"
      },
      {
        image:"https://img.icons8.com/ios/50/12B886/code-file.png",
        title:"Learn code Ethics"
      },{
        image:"https://img.icons8.com/ios-filled/50/12B886/personal-growth.png",
        title:"Personality Delevpoment Sessions",
      },{
        image:"https://img.icons8.com/ios-filled/50/12B886/google-code.png",
        title:"Work on live projects"
      },
      ]
      const data_two = [
        {
        image:"https://img.icons8.com/pastel-glyph/50/12B886/check-male.png",
        title:"Pre-placement offers"
      },
      {
        image:"https://img.icons8.com/ios/50/12B886/briefcase-settings.png",
        title:"Real-Time working Experience"
      },{
        image:"https://img.icons8.com/dotty/80/12B886/lamp.png",
        title:"Technical Experts` Guidance"
      },{
        image:"https://img.icons8.com/ios/50/12B886/help--v1.png",
        title:"Regular Feedback & Query Sessions"
      },
      ]
      const location = useLocation();

      useEffect(() => {
        if (location.state?.scrollTo) {
          const sectionId = location.state.scrollTo;
          const section = document.getElementById(sectionId);
          if (section) {
            section.scrollIntoView({ behavior: 'smooth' });
          }
        }
      }, [location]);
  return (
   <>
 
 <div className=''>
<div className="container-xxl pb-3" id='features'>

<div className="container-xxl mt-5">
  <div className="container">
    <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
    <div className='d-flex flex-row align-items-center justify-content-center mb-5'>
            <img 
                    className='pe-3'
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAACLklEQVR4nO2XT2sTQRTAn/SgYO3uzG6Tk1RRqwgW/x68SE+56ofQq36EaJP31lovfo2AINLsmy3FXPXspSfBgijGahGE3iIvkmQqDenuBsvg/OBd3mF23uzb2d8D8Hg8Ho/H85+jGR8pQy9jbl4H1wiyxlltqNcPph/OFVHN1k4qxk+jIvBbmOISuIRqP70iGx8WYeirTvEyuESQNa9qpp1BEYrpS2TwUqlFK5tYVUzvNNP7uE2Lk/I6rc8pgx1t8HvB2LPegrTTx2q2VilcgDL4YHQi+HhSPjJ4b98GphCKk/vlbgimbW2wa98O4/KzKc4rQ1tTK4BpJ+DkDJSi1zsGrdbMofNSYKceBuuJyhPRRvOmHIjVPrtRSrfABZRpnNZMH4ZtY+hXmCV3wAUWOvUTdtvJ5iNOlsEV4o2VC6O+xz2dUQ1cQxt6phjfOrl5T17k3hf11UwPwTXiLLkhyjv46ML1xgK4Qpjikm2MosCiwuACcZsWlcHP9uARpMk1cIF5Q+f/Gjh25bcPLlDZxOofabMlS5S3mC4rpjfRq9VTg/UjXrkoSi7/AHnWpHxubG2eVkSc3B2uz/TkIG0el8+NqKw9JZV2e0Nbs6+fx/tuNYNdGVxsbR6XL4QorfS91UJd+Qby6rIo9oEPaLVm+mp+2HwRFNNtZfCndQttlx80/jERJ8uiunY7QPriOLiEzqhmD95zaeMcuIbOqNZXX0OrR70Xj8fj8Xg8cMT8BtFVe5J3SM2jAAAAAElFTkSuQmCC" alt="sorting-arrows-horizontal"/>
                    <h6 className="sub_heading p">Why Choose Us</h6>
                    <img 
                    className='ps-3'
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAACLklEQVR4nO2XT2sTQRTAn/SgYO3uzG6Tk1RRqwgW/x68SE+56ofQq36EaJP31lovfo2AINLsmy3FXPXspSfBgijGahGE3iIvkmQqDenuBsvg/OBd3mF23uzb2d8D8Hg8Ho/H85+jGR8pQy9jbl4H1wiyxlltqNcPph/OFVHN1k4qxk+jIvBbmOISuIRqP70iGx8WYeirTvEyuESQNa9qpp1BEYrpS2TwUqlFK5tYVUzvNNP7uE2Lk/I6rc8pgx1t8HvB2LPegrTTx2q2VilcgDL4YHQi+HhSPjJ4b98GphCKk/vlbgimbW2wa98O4/KzKc4rQ1tTK4BpJ+DkDJSi1zsGrdbMofNSYKceBuuJyhPRRvOmHIjVPrtRSrfABZRpnNZMH4ZtY+hXmCV3wAUWOvUTdtvJ5iNOlsEV4o2VC6O+xz2dUQ1cQxt6phjfOrl5T17k3hf11UwPwTXiLLkhyjv46ML1xgK4Qpjikm2MosCiwuACcZsWlcHP9uARpMk1cIF5Q+f/Gjh25bcPLlDZxOofabMlS5S3mC4rpjfRq9VTg/UjXrkoSi7/AHnWpHxubG2eVkSc3B2uz/TkIG0el8+NqKw9JZV2e0Nbs6+fx/tuNYNdGVxsbR6XL4QorfS91UJd+Qby6rIo9oEPaLVm+mp+2HwRFNNtZfCndQttlx80/jERJ8uiunY7QPriOLiEzqhmD95zaeMcuIbOqNZXX0OrR70Xj8fj8Xg8cMT8BtFVe5J3SM2jAAAAAElFTkSuQmCC" alt="sorting-arrows-horizontal"/>
                  </div>
     
   
    </div>
    </div>
    </div>
    </div>
<div className="container-xxl">
  <div className="container">
    <div className="row">
      {data.map((i, index) => (
        <div 
          className="col-lg-3 col-md-6 col-sm-12 mb-4 d-flex justify-content-center" 
          key={index}
        >
          <div className="card text-center shadow-sm hover-effect" style={{ width: '18rem' ,border:"none"}}>
            <div className="card-body">
              <img src={i.image} width={80} height={80} className="mb-3" alt={i.title}/>
              <h6 className="card-title">{i.title}</h6>
            </div>
          </div>
        </div>
      ))}
    </div>
    <div className="row">
      {data_two.map((i, index) => (
        <div 
          className="col-lg-3 col-md-6 col-sm-12 mb-4 d-flex justify-content-center" 
          key={index}
        >
          <div className="card text-center shadow-sm hover-effect" style={{ width: '18rem',border:"none" }}>
            <div className="card-body">
              <img src={i.image} width={80} height={80} className="mb-3 " alt={i.title}/>
              <h6 className="card-title">{i.title}</h6>
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
</div>
</div>
   </>
  )
}

export default Feature